function isValidAvaxAddress(address) {
    const avaxRegex = /^(X-avax)[0-9A-Za-z]{39}$/;
    return address.search(avaxRegex) !== -1;
}

export default {
    isValidAddress(address, currency, opts = {}) {
        return isValidAvaxAddress(address);
    },
};
